module.exports = __webpack_public_path__ + "media/assets/icons/angle-double-down-a3206ae025fd7c056962d4020638712f.svg";